import { Link } from 'foundations-components/transitional/components/Link';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import IdentifyContactBadge from '../../visitor-identification/components/IdentifyContactBadge';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { ExternalLinkIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const formatJobTitleAndCompany = (jobTitle, company) => {
  if (jobTitle && company) return `${jobTitle} @ ${company}`;
  return jobTitle || company || null;
};
const EmptyIcon = () => /*#__PURE__*/_jsx("span", {});
EmptyIcon.displayName = 'EmptyIcon';
const KnownVisitorContactInfo = ({
  company,
  contactLink,
  jobTitle,
  name,
  onContactLinkClick,
  shouldDisplayIdentifyBadge
}) => {
  const subtitle = formatJobTitleAndCompany(jobTitle, company);
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    "data-test-id": "known-contact-info-highlight",
    justifyContent: "center",
    inlineSize: "100%",
    overflow: "hidden",
    children: /*#__PURE__*/_jsxs(View, {
      inlineSize: "100%",
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [shouldDisplayIdentifyBadge && /*#__PURE__*/_jsx(View, {
          marginInlineEnd: "100",
          marginBlockStart: "100",
          as: "span",
          children: /*#__PURE__*/_jsx(IdentifyContactBadge, {})
        }), /*#__PURE__*/_jsx(Link, {
          display: "flex",
          href: contactLink,
          onClick: onContactLinkClick,
          external: true,
          ExternalIcon: EmptyIcon,
          children: /*#__PURE__*/_jsxs(Flex, {
            display: "inline-flex",
            justifyContent: "start",
            children: [/*#__PURE__*/_jsx(TruncateString, {
              children: name
            }), /*#__PURE__*/_jsx(IconHolder, {
              icon: ExternalLinkIcon,
              marginInlineStart: "100",
              size: "400"
            })]
          })
        })]
      }), subtitle && /*#__PURE__*/_jsx(TruncateString, {
        children: subtitle
      })]
    })
  });
};
KnownVisitorContactInfo.displayName = 'KnownVisitorContactInfo';
export default KnownVisitorContactInfo;